import { cn } from '@/lib/utils';

interface AnimatedEllipsisProps {
  className?: string;
  dotClassName?: string;
  size?: 'sm' | 'md' | 'lg';
  color?:
    | 'primary'
    | 'secondary'
    | 'muted'
    | 'accent'
    | 'gray'
    | 'synergy-neutral';
}

export function AnimatedEllipsis({
  className,
  dotClassName,
  size = 'md',
  color = 'primary',
}: AnimatedEllipsisProps) {
  // Size mapping
  const sizeMap = {
    sm: 'w-1 h-1',
    md: 'w-2 h-2',
    lg: 'w-3 h-3',
  };

  // Color mapping
  const colorMap = {
    primary: 'bg-primary',
    secondary: 'bg-secondary',
    muted: 'bg-muted-foreground',
    accent: 'bg-accent',
    gray: 'bg-brand-indigo/40',
    'synergy-neutral': 'bg-synergy-neutral-500',
  };

  const dotSize = sizeMap[size];
  const dotColor = colorMap[color];

  return (
    <>
      {color === 'synergy-neutral' && (
        <style
          dangerouslySetInnerHTML={{
            __html: `
            @keyframes synergyNeutralPulse {
              0%, 66.66%, 100% {
                background-color: rgba(23, 12, 121, 0.3);
              }
              33.33% {
                background-color: rgba(23, 12, 121, 0.85);
              }
            }
          `,
          }}
        />
      )}
      <div className={cn('flex items-center gap-1', className)}>
        {[...Array(3)].map((_, i) => (
          <div
            key={i}
            className={cn(
              'rounded-full',
              dotSize,
              color === 'synergy-neutral'
                ? 'bg-synergy-neutral-500'
                : `animate-pulse ${dotColor}`,
              color !== 'synergy-neutral' && 'animate-pulse',
              dotClassName,
            )}
            style={{
              ...(color === 'synergy-neutral' && {
                animation: `synergyNeutralPulse 1.2s ease-in-out ${(2 - i) * -0.4}s infinite`,
              }),
              ...(color !== 'synergy-neutral' && {
                animationDelay: `${i * 200}ms`,
              }),
            }}
          />
        ))}
      </div>
    </>
  );
}
